import React, { useEffect, useState } from 'react';
import { verifyEmail } from '../services/authService';
import './VerifyEmail.css';

function VerifyEmail() {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      // Récupérer le token depuis l'URL
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Token de vérification manquant');
        return;
      }

      // Vérifier l'email
      const result = await verifyEmail(token);

      if (result.success) {
        setStatus('success');
        setMessage(result.data.message || 'Email vérifié avec succès !');
        
        // Rediriger vers la page d'accueil après 3 secondes
        setTimeout(() => {
          window.location.href = '/';
        }, 3000);
      } else {
        setStatus('error');
        setMessage(result.message || 'Erreur lors de la vérification');
      }
    };

    verifyToken();
  }, []);

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        {status === 'loading' && (
          <>
            <div className="spinner"></div>
            <h2>Vérification en cours...</h2>
            <p>Veuillez patienter pendant que nous vérifions votre email.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="success-icon">✅</div>
            <h2>Email vérifié !</h2>
            <p>{message}</p>
            <p className="redirect-message">
              Redirection vers la page d'accueil dans quelques secondes...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="error-icon">❌</div>
            <h2>Erreur de vérification</h2>
            <p>{message}</p>
            <button
              className="btn-home"
              onClick={() => window.location.href = '/'}
            >
              Retour à l'accueil
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;












